import { render } from "./Redirection.vue?vue&type=template&id=50328690"
import script from "./Redirection.vue?vue&type=script&lang=js"
export * from "./Redirection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__